import isEqual from 'lodash/isEqual';

export const simplify = (obj) => JSON.parse(JSON.stringify(obj));
export const areEqual = (obj1, obj2) => isEqual(simplify(obj1), simplify(obj2));
